import styled from 'styled-components';
import SubTitle from '../../../elements/SubTitle';
import Image from '../../../elements/Image';
var TileContainer = styled.a.withConfig({
  displayName: "ArticleTilestyles__TileContainer",
  componentId: "pantheon__sc-1rkrl5j-0"
})(["position:relative;flex:1 1 301px;display:flex;flex-direction:column;background-size:cover;text-decoration:none;min-height:300px;padding:0 30px 75px;width:calc(33.333% - 36px);font-family:", ";@media only screen and (max-width:576px){padding:0 15px 75px;}"], function (props) {
  var _props$fonts;

  return ((_props$fonts = props.fonts) == null ? void 0 : _props$fonts.body) || 'Arial';
});
var CardTitle = styled(SubTitle).withConfig({
  displayName: "ArticleTilestyles__CardTitle",
  componentId: "pantheon__sc-1rkrl5j-1"
})(["margin:0.6em 0 0.4em;line-height:1.4em;font-family:", ";color:", ";", ";"], function (props) {
  var _props$fonts2;

  return ((_props$fonts2 = props.fonts) == null ? void 0 : _props$fonts2.title) || 'Arial';
}, function (props) {
  var _props$colors;

  return ((_props$colors = props.colors) == null ? void 0 : _props$colors.title) || 'black';
}, function (props) {
  var _props$theme;

  return (_props$theme = props.theme) == null ? void 0 : _props$theme.ghostTitle;
});
var ArticleImage = styled(Image).withConfig({
  displayName: "ArticleTilestyles__ArticleImage",
  componentId: "pantheon__sc-1rkrl5j-2"
})(["width:100%;height:300px;object-fit:cover;"]);
var ReadingTime = styled.div.withConfig({
  displayName: "ArticleTilestyles__ReadingTime",
  componentId: "pantheon__sc-1rkrl5j-3"
})(["margin-top:0.5rem;color:", ";font-family:", ";", ";"], function (props) {
  var _props$colors2;

  return ((_props$colors2 = props.colors) == null ? void 0 : _props$colors2.readtime) || "black";
}, function (props) {
  var _props$fonts3;

  return ((_props$fonts3 = props.fonts) == null ? void 0 : _props$fonts3.body) || 'Arial';
}, function (props) {
  var _props$theme2;

  return (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.ghostReadTime;
});
export { TileContainer, CardTitle, ArticleImage, ReadingTime };